<template>
	<div
		class="g-block-title-slant-block g-block-title-padding"
		:class="{
			'g-block-title-slant-block--edit': editable,
			'is-active': editable && active,
			'g-block-title-slant-block--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-slant-block__row">
			<div
				class="g-block-title-slant-block__piece g-block-title-slant-block__piece--accent"
				:style="{ background: themeColor }"
				aria-hidden="true"
			></div>
			<div class="g-block-title-slant-block__piece g-block-title-slant-block__piece--core" :style="{ background: themeColor }">
				<div class="g-block-title-slant-block__content">
					<RichTextEditable
						v-if="editable"
						class="g-block-title-slant-block__text"
						fit-content
						:model-value="data.content"
						placeholder="请输入标题"
						@update:model-value="onContentUpdate"
						@focus="onWrapClick"
					/>
					<div
						v-else
						class="g-block-title-slant-block__text"
						v-html="data.content || ''"
					></div>
				</div>
			</div>
			<div
				class="g-block-title-slant-block__piece g-block-title-slant-block__piece--accent"
				:style="{ background: themeColor }"
				aria-hidden="true"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleSlantBlock',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	@slant-skew: -22deg;
	@slant-unskew: 22deg;

	.g-block-title-slant-block {
		.title-block-edit-shell();
		text-align: center;
	}

	.g-block-title-slant-block__row {
		display: inline-flex;
		align-items: stretch;
		justify-content: center;
		gap: 6px;
		max-width: 100%;
	}

	.g-block-title-slant-block__piece {
		flex-shrink: 0;
		transform: skewX(@slant-skew);
		transform-origin: center center;

		&--accent {
			width: 10px;
			align-self: stretch;
		}

		&--core {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			max-width: calc(100% - 44px);
		}
	}

	.g-block-title-slant-block__content {
		transform: skewX(@slant-unskew);
		transform-origin: center center;
		padding: 10px 24px;
		box-sizing: border-box;
	}

	.g-block-title-slant-block__text {
		display: block;
		font-size: 18px;
		font-weight: 700;
		line-height: 18px;
		color: #fff;
		text-align: center;
		white-space: nowrap;
		:deep(.g-rich-text-editable) {
			display: block;
			text-align: center;
		}
		:deep(.g-rich-text-editable__content) {
			display: inline-block;
			min-height: unset;
			padding: 0;
			font-size: 18px;
			font-weight: 700;
			line-height: 18px;
			color: inherit;
			text-align: center;
			white-space: nowrap;
			word-break: keep-all;
			vertical-align: top;
		}
	}

	.g-block-title-slant-block--h5 {
		.g-block-title-slant-block__row { gap: 0.12rem; }
		.g-block-title-slant-block__piece--accent { width: 0.2rem; }
		.g-block-title-slant-block__piece--core { max-width: calc(100% - 0.88rem); }
		.g-block-title-slant-block__content { padding: 0.2rem 0.48rem; }
		.g-block-title-slant-block__text { font-size: 0.36rem; }
	}
</style>
